/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  UselessRoyaltyReceiver,
  UselessRoyaltyReceiverInterface,
} from "../UselessRoyaltyReceiver";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_uselessNFT",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "platinumRoyaltyShareNumerator",
        type: "uint256",
      },
    ],
    name: "PlatinumRoyaltyShareNumeratorSet",
    type: "event",
  },
  {
    inputs: [],
    name: "ROYALTY_SHARE_DENOMINATOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "platinumRoyaltyShareNumerator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_platinumRoyaltyShareNumerator",
        type: "uint256",
      },
    ],
    name: "setPlatinumRoyaltyShareNumerator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uselessNFT",
    outputs: [
      {
        internalType: "contract UselessNFT",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "contract IWETH",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

export class UselessRoyaltyReceiver__factory {
  static readonly abi = _abi;
  static createInterface(): UselessRoyaltyReceiverInterface {
    return new utils.Interface(_abi) as UselessRoyaltyReceiverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UselessRoyaltyReceiver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UselessRoyaltyReceiver;
  }
}
